"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EFunctionsActions;
(function (EFunctionsActions) {
    EFunctionsActions["IMPORT_FACILITY"] = "UPDATE_FACILITY";
    EFunctionsActions["FETCH_RESIDENTS"] = "FETCH_RESIDENTS";
    EFunctionsActions["UPDATE_RESIDENTS"] = "UPDATE_RESIDENTS";
    EFunctionsActions["FETCH_TRANSACTIONS"] = "FETCH_TRANSACTIONS";
    EFunctionsActions["UPDATE_TRANSACTIONS"] = "UPDATE_TRANSACTIONS";
    EFunctionsActions["GENERATE_STATEMENTS"] = "GENERATE_STATEMENTS";
    EFunctionsActions["MAIL_STATEMENTS"] = "MAIL_STATEMENTS";
    EFunctionsActions["REGENERATE_STATEMENT"] = "REGENERATE_STATEMENT";
    EFunctionsActions["REGENERATE_STATEMENTS"] = "REGENERATE_STATEMENTS";
    EFunctionsActions["INIT_MAILING_CONTACTS"] = "INIT_MAILING_CONTACTS";
    EFunctionsActions["UPDATE_RESIDENT_CONTACTS"] = "UPDATE_RESIDENT_CONTACTS";
    EFunctionsActions["RUN_COLLECTION_FLOW"] = "RUN_COLLECTION_FLOW";
    EFunctionsActions["UPDATE_DATES_OF_SERVICES"] = "UPDATE_DATES_OF_SERVICES";
    EFunctionsActions["FETCH_RESIDENTS_AND_TRANSACTIONS"] = "FETCH_RESIDENTS_AND_TRANSACTIONS";
    EFunctionsActions["UPDATE_RESIDENTS_AND_TRANSACTIONS"] = "UPDATE_RESIDENTS_AND_TRANSACTIONS";
})(EFunctionsActions = exports.EFunctionsActions || (exports.EFunctionsActions = {}));
var EFunctionsFlowTypes;
(function (EFunctionsFlowTypes) {
    EFunctionsFlowTypes["IMPORT_FACILITY"] = "UPDATE_FACILITY";
    EFunctionsFlowTypes["UPDATE_RESIDENTS"] = "UPDATE_RESIDENTS";
    EFunctionsFlowTypes["UPDATE_TRANSACTIONS"] = "UPDATE_TRANSACTIONS";
    EFunctionsFlowTypes["GENERATE_STATEMENTS"] = "GENERATE_STATEMENTS";
})(EFunctionsFlowTypes = exports.EFunctionsFlowTypes || (exports.EFunctionsFlowTypes = {}));
var ECloudFunctionsTypes;
(function (ECloudFunctionsTypes) {
    ECloudFunctionsTypes["SEND_WORKER_REQUEST"] = "SEND_WORKER_REQUEST";
    ECloudFunctionsTypes["SEND_CRAWLER_REQUEST"] = "SEND_CRAWLER_REQUEST";
    ECloudFunctionsTypes["SEND_NCS_REQUEST"] = "SEND_NCS_REQUEST";
})(ECloudFunctionsTypes = exports.ECloudFunctionsTypes || (exports.ECloudFunctionsTypes = {}));
exports.FunctionFlow = {
    GENERATE_STATEMENTS: [
        EFunctionsActions.FETCH_RESIDENTS,
        EFunctionsActions.UPDATE_RESIDENTS,
        EFunctionsActions.FETCH_TRANSACTIONS,
        EFunctionsActions.UPDATE_TRANSACTIONS,
        EFunctionsActions.GENERATE_STATEMENTS
    ],
    IMPORT_FACILITY: [EFunctionsActions.FETCH_RESIDENTS, EFunctionsActions.UPDATE_RESIDENTS],
    UPDATE_TRANSACTIONS: [
        EFunctionsActions.FETCH_RESIDENTS,
        EFunctionsActions.UPDATE_RESIDENTS,
        EFunctionsActions.FETCH_TRANSACTIONS,
        EFunctionsActions.UPDATE_TRANSACTIONS
    ]
};
